export default "/_next/static/images/643691d23da0611711c427a5c26396f0.png";